
import React from 'react';

interface PlayerAvatarProps {
  name: string;
  imageUrl?: string;
  size?: 'small' | 'wizard' | 'medium' | 'large' | 'xlarge' | 'xxlarge';
}

const PlayerAvatar: React.FC<PlayerAvatarProps> = ({ name, imageUrl, size = 'medium' }) => {
  const getInitials = (name: string) => {
    const initials = name.split(' ').map(n => n[0]).join('');
    return initials.slice(0, 2).toUpperCase();
  };

  const FNV1a = (str: string) => {
    let hash = 2166136261;
    for (let i = 0; i < str.length; i++) {
      hash ^= str.charCodeAt(i);
      hash += (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24);
    }
    return hash >>> 0;
  };

  const colors = [
    'bg-red-600',
    'bg-amber-700',
    'bg-green-700',
    'bg-primary-700',
    'bg-indigo-600',
    'bg-purple-600',
    'bg-pink-700',
  ];

  const colorIndex = FNV1a(name) % colors.length;
  const bgColor = colors[colorIndex];

  const sizeClasses = {
    small: 'w-10 h-10 text-sm',
    wizard: 'w-12 h-12 text-base',
    medium: 'w-16 h-16 text-lg',
    large: 'w-24 h-24 text-2xl',
    xlarge: 'w-32 h-32 text-4xl',
    xxlarge: 'w-64 h-64 text-6xl',
  };

  if (imageUrl) {
    return (
      <img
        src={imageUrl}
        alt={name}
        className={`${sizeClasses[size]} rounded-full shadow-lg border-4 border-white object-cover`}
        key={imageUrl} // Force re-render when imageUrl changes
      />
    );
  }

  return (
    <div
      className={`${sizeClasses[size]} ${bgColor} rounded-full shadow-lg border-4 border-white flex items-center justify-center text-white font-bold`}
    >
      {getInitials(name)}
    </div>
  );
};

export default PlayerAvatar;
